(function(angular){
    'use strict';

    var addEditRequestTemplateMaster = function($scope: any, $state: any, $stateParams: any) {

        $scope.isEditMode = $state.is('requestTemplateEdit');
        $scope.requestTemplateId = $stateParams.requestTemplateId;

        $scope.returnToParent = function() {
                $state.go('requestTemplateList');
        };
    };

    addEditRequestTemplateMaster.$inject = [
        '$scope',
        '$state',
        '$stateParams'
    ];
    angular.module('onvio.documents').controller('addEditRequestTemplateMaster', addEditRequestTemplateMaster);

})((window as any).angular);
